module.exports = __webpack_public_path__ + "static/media/uk-popup.40923083.svg";